import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/logo/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-14de2646"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "left-block" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "haderMenu" }, null, -1))
const _hoisted_5 = { class: "v-norme-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {}
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient-fon" }, null, -1))

import { useRoute, useRouter } from "vue-router";
import * as Router from "@/router/routerNames";
import * as Routes from "@/router/routerNames";
import { onMounted, ref, Ref } from "vue";
import LocaleSwitcher from "@/locales/LocaleSwitcher.vue";
// import apiconfig from "../../../public/appWebSettings.json"

export default /*#__PURE__*/_defineComponent({
  __name: 'layout-header-simple',
  setup(__props) {

const route = useRoute();
const router = useRouter();
let landingUrl = ref("");
onMounted(async () => {
  loadSettings();
});
function goHome() {
  window.location.replace(landingUrl.value);
}

async function loadSettings() {
  try {
    // Запрашиваем файл appWebSettings.json из папки public
    const response = await fetch("/appWebSettings.json");

    // Проверяем, что запрос успешен
    if (!response.ok) {
      throw new Error("Error");
    }

    // Преобразуем ответ в JSON
    const settings = await response.json();
    landingUrl.value = settings.landingUrl;
    // Сохраняем нужные параметры в переменные
  } catch (error) {
    console.error("Error:", error);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goHome()))
            }, _hoisted_7)
          ])
        ])
      ]),
      _createVNode(LocaleSwitcher)
    ]),
    _hoisted_8
  ], 64))
}
}

})